const BOOLEAN_TYPES = ['agree-check', 'terms']
const TEXT_TYPES = [
  'text',
  'long-text',
  'url',
  'phone-number',
  'github',
  'instagram',
  'linkedin',
  'telegram',
  'twitter',
  'youtube'
]

export const hasRegistrationQuestions = (questions = []) =>
  Array.isArray(questions) && questions.length > 0

export const phoneNumberQuestion = (questions = []) =>
  questions.find((question) => question.questionType === 'phone-number')

export const registrationDefaultsHasPhone = (registrationDefaults = {}) => {
  const phoneRequirement = registrationDefaults?.phoneNumberRequirement
  return phoneRequirement === 'required' || phoneRequirement === 'optional'
}

export const questionsForForm = (questions = [], registrationDefaults = {}) => {
  if (!registrationDefaultsHasPhone(registrationDefaults)) return questions

  return questions.filter(
    (question) => question.questionType !== 'phone-number'
  )
}

export const validateDefaultPhone = (
  registrationDefaults = {},
  phoneNumber = '',
  questions = []
) => {
  if (!registrationDefaultsHasPhone(registrationDefaults)) return null
  if (phoneNumberQuestion(questions)) return null

  if (
    registrationDefaults.phoneNumberRequirement === 'required' &&
    !String(phoneNumber || '').trim()
  ) {
    return 'Phone number is required.'
  }

  return null
}

export const validateDefaultName = (
  registrationDefaults = {},
  nameFields = {}
) => {
  const nameRequirement = registrationDefaults?.nameRequirement || 'full-name'
  const errors = {}

  if (nameRequirement === 'first-last') {
    if (!String(nameFields.firstName || '').trim()) {
      errors.firstName = 'First name is required.'
    }
    if (!String(nameFields.lastName || '').trim()) {
      errors.lastName = 'Last name is required.'
    }
  } else if (!String(nameFields.fullName || '').trim()) {
    errors.fullName = 'Name is required.'
  }

  return Object.keys(errors).length ? errors : null
}

export const buildGuestNamePayload = (
  registrationDefaults = {},
  nameFields = {}
) => {
  const nameRequirement = registrationDefaults?.nameRequirement || 'full-name'

  if (nameRequirement === 'first-last') {
    return {
      firstName: String(nameFields.firstName || '').trim(),
      lastName: String(nameFields.lastName || '').trim()
    }
  }

  return {
    guestName: String(nameFields.fullName || '').trim()
  }
}

export const mergePhoneAnswer = (
  questions = [],
  answers = {},
  phoneNumber = '',
  registrationDefaults = {}
) => {
  if (!registrationDefaultsHasPhone(registrationDefaults)) return answers

  const phoneQuestion = phoneNumberQuestion(questions)
  if (!phoneQuestion || answers[phoneQuestion.id]) return answers

  const trimmed = String(phoneNumber || '').trim()
  if (!trimmed) return answers

  return { ...answers, [phoneQuestion.id]: trimmed }
}

export const splitRegistrationQuestions = (questions = []) => {
  const termsQuestions = questions.filter(
    (question) => question.questionType === 'terms'
  )
  const otherQuestions = questions.filter(
    (question) => question.questionType !== 'terms'
  )

  return { otherQuestions, termsQuestions }
}

export const getRegistrationStepCount = (questions = []) => {
  const { otherQuestions, termsQuestions } =
    splitRegistrationQuestions(questions)
  if (otherQuestions.length && termsQuestions.length) return 2
  return 1
}

export const validateQuestions = (questions = [], answers = {}) => {
  const errors = {}
  questions.forEach((question) => {
    if (!isAnswerPresent(question, answers[question.id])) {
      errors[question.id] = 'This field is required.'
    }
  })
  return errors
}

export const isAnswerPresent = (question, value) => {
  if (!question?.required) return true

  switch (question.questionType) {
    case 'agree-check':
    case 'terms':
      return value === true
    case 'multi-select':
      return Array.isArray(value) && value.some(Boolean)
    case 'company':
      return Boolean(value?.company?.trim() || value?.jobTitle?.trim())
    default:
      return Boolean(value && String(value).trim())
  }
}

export const buildRegistrationAnswersPayload = (questions = [], answers = {}) =>
  questions
    .map((question) => ({
      question_id: question.id,
      value: formatAnswerValue(question, answers[question.id])
    }))
    .filter((answer) => answer.question_id)

const formatAnswerValue = (question, value) => {
  switch (question.questionType) {
    case 'agree-check':
    case 'terms':
      return value === true
    case 'multi-select':
      return Array.isArray(value) ? value.filter(Boolean) : []
    case 'company':
      return {
        company: value?.company?.trim() || null,
        job_title: value?.jobTitle?.trim() || null
      }
    default:
      return value?.trim?.() ? value.trim() : value || null
  }
}

export { BOOLEAN_TYPES, TEXT_TYPES }
